import React from "react";
import { Container, Row, Col, Button, Badge } from "react-bootstrap";
import { motion } from "framer-motion";
import { ArrowRight, Code } from "lucide-react";
import logo from "../imagem/logo.png";

function Hero() {
  return (
    <section className="hero-elite-transparent overflow-hidden">
      <Container className="h-100 d-flex align-items-center justify-content-center">
        <Row className="gy-5 w-100 justify-content-center">
          <Col lg={10} xl={9} className="text-center">
            <motion.div
              initial={{ opacity: 1, scale: 1 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img
                src={logo}
                alt="Henrimack Elite Software"
                className="hero-logo-premium-responsive mb-4 mb-md-5"
              />

              <Badge bg="transparent" className="badge-luxury-hero mb-3 mb-md-4">
                <span className="glow-dot"></span> ENGENHARIA DE SOFTWARE DE ELITE
              </Badge>

              <h1 className="hero-title-responsive fw-900 mb-3 mb-md-4">
                Arquitetura Digital de <br />
                <span className="text-gold title-shine">Alta Performance</span>
              </h1>

              <p className="hero-subtitle-responsive mx-auto mb-5 mb-md-10">
                Desenvolvemos o <strong className="text-gold">SGE Pro</strong> e ecossistemas críticos para
                o setor de <strong>eventos e locação de móveis</strong>. Tecnologia de elite para operações complexas.
              </p>

              <div className="d-flex flex-column flex-md-row gap-3 gap-md-4 justify-content-center align-items-center">
                <Button href="/sge-pro" className="btn-hero-primary-elite">
                  EXPLORAR SGE PRO <ArrowRight size={20} className="ms-2" />
                </Button>
                <Button href="#contact" className="btn-hero-secondary-elite">
                  <Code size={20} className="me-2" /> SOLUÇÕES SOB MEDIDA
                </Button>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .hero-elite-transparent {
          min-height: 100vh;
          width: 100%;
          background: transparent;
          position: relative;
          display: flex;
          align-items: center;
          padding-top: 100px;
          padding-bottom: 60px;
        }

        .hero-logo-premium-responsive {
          max-height: clamp(80px, 15vw, 150px);
          filter: drop-shadow(0 0 30px rgba(228, 168, 122, 0.4));
        }

        .badge-luxury-hero {
          border: 1px solid rgba(228, 168, 122, 0.3);
          color: var(--elite-gold);
          letter-spacing: 2px;
          padding: 8px 18px;
          border-radius: 50px;
          font-weight: 800;
          font-size: 0.6rem;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }

        .glow-dot {
          width: 6px; height: 6px;
          background: var(--elite-gold);
          border-radius: 50%;
          box-shadow: 0 0 10px var(--elite-gold);
        }

        .hero-title-responsive {
          font-size: clamp(2rem, 8vw, 4.5rem);
          line-height: 1.1;
          font-weight: 900;
          color: #fff;
          letter-spacing: -1px;
        }

        .hero-subtitle-responsive {
          color: #aaa;
          font-size: clamp(1rem, 4vw, 1.25rem);
          max-width: 800px;
          line-height: 1.7;
        }

        .btn-hero-primary-elite {
          background: var(--elite-gold);
          color: #000 !important;
          border: none;
          padding: 1.2rem 2.5rem;
          border-radius: 12px;
          font-weight: 800;
          letter-spacing: 1px;
          transition: all 0.4s ease;
          box-shadow: 0 15px 40px rgba(228, 168, 122, 0.3);
          width: 100%;
          max-width: 320px;
        }

        .btn-hero-primary-elite:hover {
          background: #fff;
          transform: translateY(-5px);
          box-shadow: 0 20px 60px rgba(228, 168, 122, 0.5);
        }

        .btn-hero-secondary-elite {
          background: rgba(255,255,255,0.03);
          color: #fff !important;
          border: 1px solid rgba(255,255,255,0.1);
          padding: 1.2rem 2.5rem;
          border-radius: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          backdrop-filter: blur(10px);
          transition: all 0.4s ease;
          width: 100%;
          max-width: 320px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-hero-secondary-elite:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          transform: translateY(-5px);
        }

        @media (min-width: 768px) {
          .btn-hero-primary-elite, .btn-hero-secondary-elite {
            width: auto;
          }
        }

        @media (max-width: 576px) {
          .hero-elite-transparent {
            padding-top: 120px;
          }
        }
      `}</style>
    </section>
  );
}

export default Hero;
